import React from 'react'

// apollo
import { useQuery } from '@apollo/client'
import { GET_JOB_DAY_BY_ID_WITH_TIME_TICKET_STATS } from '../../../../../graphql/jobDay/jobDay.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'

const workTypeChoices = {
    TM: "T & M",
    CW: "Contract Work",
    YW: "Yard Work",
}

const workType2Choices = {
    IN: "Interior",
    EX: "Exterior"
}

const workType1Choices = {
    E: "Erect",
    D: "Dismantle"
}
const JobDayTimeTicketStats = ({ id }) => {

    const { data } = useQuery(GET_JOB_DAY_BY_ID_WITH_TIME_TICKET_STATS, {
        variables: { id }
    })

    let jobDay = {}

    if(data && data.jobDay) {
        jobDay = {...data.jobDay}
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faInfo} size='2x' color='#707070' />, title: "Time Ticket"}}>
        <CardDataPoint label="Work Type" value={data ? workTypeChoices[jobDay.workType] : ""} />
        <CardDataPoint label="Interior/Exterior?" value={data ? workType2Choices[jobDay.workType2] : ""} />
        <CardDataPoint label="Erect/Dismantle?" value={data ? workType1Choices[jobDay.workType1] : ""} />
        <CardDataPoint label="# of Frames" value={data ? jobDay.numFrames : ""} />
    </Card>)
}

export default JobDayTimeTicketStats